import { RootRoute } from '@app/const';
import { BehaviorSubject } from '@app/types';
// This import is deep to help prevent circular dependencies.
import { getRootRoute, navigateToRoute } from '@app/utilities/functions/router';
import { useSubject } from './useSubject';

/** Subject tracking the active @see RootRoute. */
const routeSubject = (function createRouteSubject() {
  const subject = new BehaviorSubject(getRootRoute());
  const routeChanged = () => {
    const newRoute = getRootRoute();
    if (newRoute !== subject.value) {
      subject.next(newRoute);
    }
  };
  window.addEventListener('hashchange', routeChanged);
  window.addEventListener('popstate', routeChanged);

  // Listen to methods without event listeners.
  const { pushState, replaceState } = window.history;
  window.history.pushState = function (...args) {
    const result = pushState.apply(this, args);
    routeChanged();
    return result;
  };
  window.history.replaceState = function (...args) {
    const result = replaceState.apply(this, args);
    routeChanged();
    return result;
  };
  return subject;
})();

export function useRootRoute(): [RootRoute, (newRoute: RootRoute) => void] {
  const route = useSubject(routeSubject, routeSubject.value);
  return [route, navigateToRoute];
}
